<svg:defs>
  <pattern
    [attr.id]="patternId"
    width="10"
    height="10"
    patternUnits="userSpaceOnUse"
    [attr.patternTransform]="patternTransform$ | async"
  >
    <line x1="5" y1="0" x2="5" y2="10" stroke-width="5" />
  </pattern>
</svg:defs>

<svg:polygon
  [class.outline]="outline"
  [style.fill]="getFill()"
  [attr.points]="getPointString(points)"
  [class.ml-loading]="mlIsLoading"
/>
